// @ts-nocheck
import React from "react";
import { Container } from "../SobreTranscricao/styles";

// "2026-08-28T00:00:00.000000Z" -> "28/08/2026" (só a parte da data, sem
// converter fuso: meia-noite UTC viraria o dia anterior no Brasil)
const formatarData = (data) => {
  const [ano, mes, dia] = (data || "").slice(0, 10).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : null;
};

// Mensagem do processo destravado (etapa "unblocked").
export default function ObstaculoResolvido({ process, isEssential }) {
  if (process?.step?.name !== "unblocked") return null;

  const data = formatarData(process?.unblocked_date);

  return (
    <Container>
      <strong>
        {data ? `Obstáculo resolvido em ${data}` : "Obstáculo resolvido"}
      </strong>
      <p>
        {isEssential
          ? "A reanálise aprovou a documentação. O pedido segue para o envio a Portugal."
          : "A reanálise aprovou a documentação. O pedido segue para o apostilamento e depois para o envio a Portugal."}
      </p>
    </Container>
  );
}
